const NMIII_ADDON_TITLES = ['Premium Gift Wrap', 'Personalized Letter'];
const NMIII_ADDON_HANDLES = ['premium-gift-wrap', 'personalized-letter'];

let nmiiiLastCart = null;
let nmiiiAddonNesting = false;
let nmiiiAddonNestTimer = null;
let nmiiiRemovingOrphans = false;
let nmiiiLastNestAt = 0;
let nmiiiAddonObserver = null;

function nmiiiCartUrl(path) {
  const root = (window.routes && window.routes.cart_url) || '/cart';
  return root.replace(/\/$/, '') + path;
}

function nmiiiIsAddonItem(item) {
  const handle = item.handle || '';
  const title = item.product_title || item.title || '';
  const properties = item.properties || {};
  return Boolean(
    (item.parent_relationship && item.parent_relationship.parent_key) ||
      properties._is_addon === 'true' ||
      NMIII_ADDON_HANDLES.indexOf(handle) !== -1 ||
      NMIII_ADDON_TITLES.indexOf(title) !== -1
  );
}

function nmiiiFormatMoney(cents) {
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    return window.Shopify.formatMoney(cents);
  }
  return 'Rs. ' + (Number(cents) / 100).toFixed(2);
}

function nmiiiNormalize(text) {
  return (text || '').replace(/\s+/g, ' ').trim();
}

function nmiiiTextMatchesTitle(text, title) {
  const a = nmiiiNormalize(text).toLowerCase();
  const b = nmiiiNormalize(title).toLowerCase();
  if (!a || !b) return false;
  if (a === b) return true;
  if (a.indexOf(b) !== -1 || (a.length >= 18 && b.indexOf(a) !== -1)) return true;
  const snippet = b.slice(0, 24);
  return snippet.length >= 12 && a.indexOf(snippet) !== -1;
}

function nmiiiContainsParentProduct(el) {
  if (!el || !nmiiiLastCart) return false;
  const text = nmiiiNormalize(el.textContent).toLowerCase();
  return (nmiiiLastCart.items || []).some(function (item) {
    if (nmiiiIsAddonItem(item)) return false;
    const words = nmiiiNormalize(item.product_title || item.title)
      .toLowerCase()
      .split(' ')
      .filter(function (word) {
        return word.length > 3;
      });
    let hits = 0;
    words.forEach(function (word) {
      if (text.indexOf(word) !== -1) hits += 1;
    });
    return hits >= 2;
  });
}

function nmiiiFindRowByTitle(title, skipHidden, addonOnly) {
  const images = document.querySelectorAll('img');
  const candidates = [];
  const maxHeight = addonOnly ? 280 : 520;
  for (let i = 0; i < images.length; i++) {
    const img = images[i];
    if (img.closest('.nmiii-cart-addons')) continue;
    if (skipHidden && img.closest('.nmiii-addon-hidden, .nmiii-addon-slot-collapse')) continue;
    let el = img.parentElement;
    for (let depth = 0; depth < 12 && el && el !== document.body; depth++) {
      if (nmiiiTextMatchesTitle(el.textContent, title)) {
        const height = el.getBoundingClientRect().height;
        if (height >= 40 && height <= maxHeight) {
          if (!addonOnly || !nmiiiContainsParentProduct(el)) {
            candidates.push({ el: el, height: height });
          }
        }
      }
      el = el.parentElement;
    }
  }
  candidates.sort(function (a, b) {
    return a.height - b.height;
  });
  return candidates.length ? candidates[0].el : null;
}

function nmiiiLooksLikeDivider(el) {
  if (!el || el.classList.contains('nmiii-cart-addons')) return false;
  if (el.querySelector && el.querySelector('img')) return false;
  if (el.tagName === 'HR') return true;
  const height = el.getBoundingClientRect().height;
  const text = nmiiiNormalize(el.textContent);
  return height > 0 && height <= 24 && text.length < 4;
}

function nmiiiForceHide(el) {
  if (!el || el.classList.contains('nmiii-cart-addons')) return;
  if (el.hasAttribute('data-nmiii-parent-key') && nmiiiContainsParentProduct(el)) return;
  el.classList.add('nmiii-addon-slot-collapse');
  el.setAttribute('hidden', '');
  el.style.setProperty('display', 'none', 'important');
  el.style.setProperty('height', '0', 'important');
  el.style.setProperty('max-height', '0', 'important');
  el.style.setProperty('min-height', '0', 'important');
  el.style.setProperty('margin', '0', 'important');
  el.style.setProperty('padding', '0', 'important');
  el.style.setProperty('border', 'none', 'important');
  el.style.setProperty('overflow', 'hidden', 'important');
}

function nmiiiClearHide(el) {
  el.classList.remove('nmiii-addon-hidden');
  el.classList.remove('nmiii-addon-slot-collapse');
  el.removeAttribute('hidden');
  ['display', 'height', 'max-height', 'min-height', 'margin', 'padding', 'border', 'overflow', 'position', 'left', 'width'].forEach(function (prop) {
    el.style.removeProperty(prop);
  });
}

function nmiiiCollapseUp(hiddenRow) {
  let el = hiddenRow;
  for (let depth = 0; depth < 10 && el && el.parentElement; depth++) {
    const parent = el.parentElement;
    if (nmiiiContainsParentProduct(parent)) {
      nmiiiForceHide(el);
      if (nmiiiLooksLikeDivider(el.nextElementSibling)) nmiiiForceHide(el.nextElementSibling);
      if (nmiiiLooksLikeDivider(el.previousElementSibling)) nmiiiForceHide(el.previousElementSibling);
      return;
    }
    nmiiiForceHide(el);
    el = parent;
  }
}

function nmiiiHideLeftoverListSlots(parentRows) {
  if (!parentRows.length) return;
  let node = parentRows[0];
  while (node && node.parentElement) {
    const parent = node.parentElement;
    const kids = Array.from(parent.children);
    const matched = kids.filter(function (kid) {
      return parentRows.some(function (row) {
        return kid === row || kid.contains(row);
      });
    });
    const extraAddons = kids.filter(function (kid) {
      if (matched.indexOf(kid) !== -1) return false;
      if (kid.classList.contains('nmiii-cart-addons')) return false;
      if (nmiiiLooksLikeDivider(kid)) return true;
      if (nmiiiContainsParentProduct(kid)) return false;
      const text = (kid.textContent || '').toLowerCase();
      return NMIII_ADDON_TITLES.some(function (title) {
        return text.indexOf(title.toLowerCase()) !== -1;
      });
    });
    if (matched.length === parentRows.length && extraAddons.length) {
      extraAddons.forEach(nmiiiForceHide);
      return;
    }
    node = parent;
  }
}

function nmiiiHideAddonCard(row) {
  if (!row || nmiiiContainsParentProduct(row)) return;
  if (row.getBoundingClientRect().height > 280) return;
  row.classList.add('nmiii-addon-hidden');
  nmiiiCollapseUp(row);
}

function nmiiiLeafTitleNodes(title) {
  const wanted = nmiiiNormalize(title);
  if (!wanted) return [];
  const matches = [];
  const nodes = document.querySelectorAll('a, h2, h3, h4, p, span, div, li, button');
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];
    if (node.closest('cart-drawer, cart-items, .nmiii-cart-addons')) continue;
    if (!nmiiiTextMatchesTitle(node.textContent, wanted)) continue;
    const childHasSame = Array.from(node.children).some(function (child) {
      return nmiiiTextMatchesTitle(child.textContent, wanted);
    });
    if (childHasSame) continue;
    matches.push(node);
  }
  return matches;
}

function nmiiiFindProductRow(titleNode) {
  let el = titleNode;
  for (let depth = 0; depth < 14 && el && el !== document.body; depth++) {
    const img = el.querySelector && el.querySelector('img');
    const height = el.getBoundingClientRect ? el.getBoundingClientRect().height : 0;
    if (img && height >= 70 && height <= 420) return el;
    el = el.parentElement;
  }
  return (
    titleNode.closest('[class*="line-item"], [class*="LineItem"], [class*="cart-item"], [class*="CartItem"], li, article') ||
    titleNode.parentElement
  );
}

function nmiiiPairAddons(items) {
  const byParentKey = {};
  const orphans = [];
  const used = {};

  items.forEach(function (item) {
    if (nmiiiIsAddonItem(item)) return;
    byParentKey[item.key] = [];
  });

  items.forEach(function (item) {
    if (!nmiiiIsAddonItem(item)) return;
    const parentKey = item.parent_relationship && item.parent_relationship.parent_key;
    const group = item.properties && item.properties._addon_group;
    let parent = null;
    if (parentKey) {
      parent = items.find(function (candidate) {
        return candidate.key === parentKey;
      });
    }
    if (!parent && group) {
      parent = items.find(function (candidate) {
        return !nmiiiIsAddonItem(candidate) && candidate.properties && candidate.properties._addon_group === group;
      });
    }
    if (parent && byParentKey[parent.key]) {
      byParentKey[parent.key].push(item);
      used[item.key] = true;
    }
  });

  let currentParent = null;
  items.forEach(function (item) {
    if (!nmiiiIsAddonItem(item)) {
      currentParent = item;
      return;
    }
    if (used[item.key]) return;
    if (currentParent && byParentKey[currentParent.key]) {
      byParentKey[currentParent.key].push(item);
      used[item.key] = true;
    } else {
      orphans.push(item);
    }
  });

  items.forEach(function (item) {
    if (nmiiiIsAddonItem(item) && !used[item.key]) orphans.push(item);
  });

  return { byParentKey: byParentKey, orphans: orphans };
}

function nmiiiEnsureAddonStyles() {
  let style = document.getElementById('nmiii-cart-addon-styles');
  if (!style) {
    style = document.createElement('style');
    style.id = 'nmiii-cart-addon-styles';
    document.head.appendChild(style);
  }
  style.textContent = `
    .nmiii-addon-hidden,
    .nmiii-addon-slot-collapse {
      display: none !important;
      height: 0 !important;
      max-height: 0 !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      border: none !important;
      overflow: hidden !important;
    }
    .nmiii-cart-addons {
      display: flex;
      flex-direction: column;
      gap: 4px;
      width: 100%;
      box-sizing: border-box;
      padding: 2px 16px 6px 72px;
      margin: 0;
    }
    .nmiii-cart-addon { display:flex; align-items:flex-start; gap:8px; color:#6b6b6b; font-size:13px; line-height:1.4; }
    .nmiii-cart-addon__dot { width:6px; height:6px; margin-top:7px; flex-shrink:0; border-radius:50%; background:#c5c5c5; }
    .nmiii-cart-addon__copy { display:flex; flex-direction:column; gap:2px; min-width:0; flex:1; }
    .nmiii-cart-addon__title { color:#4a4a4a; }
    .nmiii-cart-addon__note { font-size:12px; color:#8a8a8a; }
    .nmiii-cart-addon__meta { margin-left:auto; padding-left:8px; white-space:nowrap; color:#1a1a1a; }
  `;
}

function nmiiiBuildAddonRow(item) {
  const wrap = document.createElement('div');
  wrap.className = 'nmiii-cart-addon';
  const note = item.properties && item.properties['Letter message'] ? item.properties['Letter message'] : '';
  wrap.innerHTML =
    '<span class="nmiii-cart-addon__dot" aria-hidden="true"></span>' +
    '<span class="nmiii-cart-addon__copy">' +
    '<span class="nmiii-cart-addon__title"></span>' +
    (note ? '<span class="nmiii-cart-addon__note"></span>' : '') +
    '</span>' +
    '<span class="nmiii-cart-addon__meta"></span>';
  wrap.querySelector('.nmiii-cart-addon__title').textContent = item.product_title || item.title;
  if (note) wrap.querySelector('.nmiii-cart-addon__note').textContent = note;
  wrap.querySelector('.nmiii-cart-addon__meta').textContent =
    'Qty ' + item.quantity + '  ' + nmiiiFormatMoney(item.final_line_price);
  return wrap;
}

function nmiiiRemoveItems(keys) {
  const unique = keys.filter(Boolean).filter(function (key, index, list) {
    return list.indexOf(key) === index;
  });
  if (!unique.length || nmiiiRemovingOrphans) return Promise.resolve();
  const updates = {};
  unique.forEach(function (key) {
    updates[key] = 0;
  });
  nmiiiRemovingOrphans = true;
  return fetch(nmiiiCartUrl('/update.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ updates: updates }),
  })
    .catch(function () {})
    .finally(function () {
      nmiiiRemovingOrphans = false;
      nmiiiScheduleNest();
    });
}

function nmiiiNestCartAddons() {
  if (nmiiiAddonNesting || nmiiiRemovingOrphans) return;
  nmiiiAddonNesting = true;

  fetch(nmiiiCartUrl('.js'))
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      nmiiiLastCart = cart;
      const items = cart.items || [];
      const paired = nmiiiPairAddons(items);

      if (paired.orphans.length) {
        return nmiiiRemoveItems(paired.orphans.map(function (item) {
          return item.key;
        }));
      }

      const parents = items.filter(function (item) {
        return !nmiiiIsAddonItem(item);
      });
      const addons = items.filter(nmiiiIsAddonItem);

      document.querySelectorAll('.nmiii-cart-addons').forEach(function (list) {
        list.remove();
      });
      document.querySelectorAll('.nmiii-addon-hidden, .nmiii-addon-slot-collapse').forEach(nmiiiClearHide);
      document.querySelectorAll('[data-nmiii-parent-key]').forEach(function (el) {
        el.removeAttribute('data-nmiii-parent-key');
        el.removeAttribute('data-nmiii-addon-keys');
      });

      nmiiiEnsureAddonStyles();

      if (!addons.length || !parents.length) return;

      if (nmiiiAddonObserver) nmiiiAddonObserver.disconnect();

      NMIII_ADDON_TITLES.forEach(function (title) {
        let guard = 0;
        let row = nmiiiFindRowByTitle(title, true, true);
        while (row && guard < 8) {
          nmiiiHideAddonCard(row);
          if (!row.classList.contains('nmiii-addon-hidden')) break;
          guard += 1;
          row = nmiiiFindRowByTitle(title, true, true);
        }
      });

      const parentRows = [];
      parents.forEach(function (parent) {
        const childAddons = paired.byParentKey[parent.key] || [];
        if (!childAddons.length) return;
        const row = nmiiiFindRowByTitle(parent.product_title || parent.title, true);
        if (!row) return;
        parentRows.push(row);

        const list = document.createElement('div');
        list.className = 'nmiii-cart-addons';
        const addonKeys = childAddons
          .map(function (addon) {
            return addon.key;
          })
          .join(',');
        childAddons.forEach(function (addon) {
          list.appendChild(nmiiiBuildAddonRow(addon));
        });
        row.insertAdjacentElement('afterend', list);
        row.setAttribute('data-nmiii-parent-key', parent.key);
        row.setAttribute('data-nmiii-addon-keys', addonKeys);
        list.setAttribute('data-nmiii-parent-key', parent.key);
        list.setAttribute('data-nmiii-addon-keys', addonKeys);
      });
      nmiiiHideLeftoverListSlots(parentRows);
    })
    .catch(function () {})
    .finally(function () {
      if (nmiiiAddonObserver) {
        nmiiiAddonObserver.observe(document.documentElement, { childList: true, subtree: true });
      }
      nmiiiLastNestAt = Date.now();
      nmiiiAddonNesting = false;
    });
}

function nmiiiScheduleNest() {
  if (nmiiiAddonNesting || nmiiiRemovingOrphans) return;
  if (Date.now() - nmiiiLastNestAt < 400 && document.querySelector('.nmiii-cart-addons')) return;
  clearTimeout(nmiiiAddonNestTimer);
  nmiiiAddonNestTimer = setTimeout(nmiiiNestCartAddons, 250);
}

document.addEventListener(
  'click',
  function (event) {
    const row = event.target.closest('[data-nmiii-addon-keys]');
    if (!row) return;
    if (event.target.closest('.nmiii-cart-addons')) return;
    if (event.target.closest('[class*="quantity"], [class*="Quantity"], [class*="qty"]')) return;

    const control = event.target.closest('button, a, [role="button"]');
    if (!control) return;
    const label = ((control.getAttribute('aria-label') || '') + ' ' + (control.getAttribute('title') || '')).toLowerCase();
    const isRemove = /remove|delete|trash/.test(label);
    if (!isRemove) return;

    const addonKeys = (row.getAttribute('data-nmiii-addon-keys') || '').split(',');
    const parentKey = row.getAttribute('data-nmiii-parent-key');
    if (!addonKeys.filter(Boolean).length) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    nmiiiRemoveItems([parentKey].concat(addonKeys));
  },
  true
);

document.addEventListener('DOMContentLoaded', nmiiiScheduleNest);
document.addEventListener('cart:updated', nmiiiScheduleNest);
if (window.subscribe && window.PUB_SUB_EVENTS) {
  try {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, nmiiiScheduleNest);
  } catch (error) {}
}

nmiiiAddonObserver = new MutationObserver(function () {
  nmiiiScheduleNest();
});
nmiiiAddonObserver.observe(document.documentElement, { childList: true, subtree: true });
